import React from "react";
import "./Hiking.css";
import trek from "../../img/about/trek.png";

function Hiking() {
  return (
    <div className="Hiking">
     <div className="Hiking__mobile__img">
     <img src={trek} alt="Luxury villa with sea view in Costa Blanca, Spain" />
     </div>
      <div className="Hiking__txt">
        <h1>hiking</h1>
        <p>
          Hiking in the Costa Blanca offers a rewarding outdoor experience,
          allowing you to immerse yourself in the region's natural beauty and
          discover its hidden gems. Whether you're a casual walker or an
          experienced trekker, there's a trail waiting for you to explore.
          <br />
          <br /> Among multiple options, Montgó Natural Park, located near the
          town of Jávea (Xàbia), a striking limestone mountain offers numerous
          hiking trails amidst its diverse flora and fauna and provides
          challenging routes with rewarding views of the Mediterranean Sea and
          the surrounding area. Ifach Rock: The iconic Penyal d'Ifac (Ifach
          Rock) in Calpe is a prominent limestone outcrop rising 332 meters
          above the Mediterranean Sea. A hiking trail leads to the summit,
          offering panoramic views of the coast and Calpe town.
        </p>
      </div>
      <div className="Hiking__img">
        <img src={trek} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default Hiking;
